module.exports = __webpack_public_path__ + "img/524-63dc25.png";